import { sendPasswordResetEmail as firebaseSendPasswordResetEmail } from 'firebase/auth';
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, signOut, onAuthStateChanged, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from './config';
import { collection, getDocs } from 'firebase/firestore';

export const authService = {
    async sendPasswordResetEmail(email) {
        try {
            await firebaseSendPasswordResetEmail(auth, email);
        } catch (error) {
            throw new Error(error.message || 'Erro ao enviar email de redefinição.');
        }
    },

    async registerWithEmail(email, password) {
        try {
            const result = await createUserWithEmailAndPassword(auth, email, password);
            const isAdmin = await this.isUserAdmin(result.user.uid);
            if (!isAdmin) {
                await signOut(auth);
                throw new Error(`Usuário registrado, mas não autorizado como admin.\nSeu UID é: ${result.user.uid}`);
            }
            return result.user;
        } catch (error) {
            throw new Error(error.message || 'Falha ao registrar com email e senha.');
        }
    },


    async testFetchAdmins() {
        try {
            if (!db) {
                throw new Error('Firestore não está configurado corretamente');
            }
            const adminsRef = collection(db, 'admins');
            const querySnapshot = await getDocs(adminsRef);
            if (querySnapshot.empty) {
                alert('Nenhum admin encontrado. Verifique o console (F12) para instruções.');
                return [];
            }
            const adminsList = [];
            querySnapshot.forEach(doc => {
                const adminData = {
                    id: doc.id,
                    ...doc.data()
                };
                adminsList.push(adminData);
            });
            alert(`${querySnapshot.size} admin(s) encontrado(s). Verifique o console para detalhes.`);
            return adminsList;
        } catch (error) {
            console.error('\nErro ao acessar o Firestore:', error);
            alert('Erro ao acessar o Firestore. Verifique o console (F12) para detalhes.');
            throw error;
        }
    },
    async loginWithEmail(email, password) {
        try {
            const result = await signInWithEmailAndPassword(auth, email, password);
            const isAdmin = await this.isUserAdmin(result.user.uid);
            if (!isAdmin) {
                await signOut(auth);
                throw new Error(`Usuário não autorizado. Apenas administradores podem fazer login.\nSeu UID é: ${result.user.uid}`);
            }
            return result.user;
        } catch (error) {
            throw new Error(error.message || 'Falha na autenticação com email e senha.');
        }
    },

    async listAllAdmins() {
        try {
            const adminsRef = collection(db, 'admins');
            const adminsSnap = await getDocs(adminsRef);
            
            const adminsList = adminsSnap.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            
            return adminsList;
        } catch (error) {
            console.error('Erro ao listar admins:', error);
            throw error;
        }
    },

    async isUserAdmin(uid) {
        try {
            const allAdmins = await this.listAllAdmins();
            const isAdmin = allAdmins.some(admin => admin.id === uid);
            return isAdmin;
        } catch (error) {
            console.error('Erro ao verificar status de admin:', error);
            return false;
        }
    },

    async loginWithGoogle() {
        try {
            console.log('=== Iniciando processo de login com Google ===');
            const provider = new GoogleAuthProvider();
            
            console.log('Solicitando login via popup...');
            const result = await signInWithPopup(auth, provider);
            
            console.log('Login Google bem sucedido!');
            console.log('Informações do usuário:', {
                uid: result.user.uid,
                email: result.user.email,
                nome: result.user.displayName
            });
            
            console.log('Verificando permissões de admin...');
            const isAdmin = await this.isUserAdmin(result.user.uid);
            
            if (!isAdmin) {
                console.log('Usuário não tem permissões de admin');
                console.log('Fazendo logout...');
                await signOut(auth);
                throw new Error(`Usuário não autorizado. Apenas administradores podem fazer login.\nSeu UID é: ${result.user.uid}`);
            }

            console.log('=== Login completo: usuário é admin ===');
            return result.user;
        } catch (error) {
            console.error('Erro no login:', error);
            throw new Error(error.message || 'Falha na autenticação com Google.');
        }
    },

    async logout() {
        try {
            await signOut(auth);
        } catch (error) {
            console.error('Erro no logout:', error);
            throw new Error('Falha ao fazer logout.');
        }
    },

    getCurrentUser() {
        return new Promise((resolve, reject) => {
            const unsubscribe = onAuthStateChanged(auth, 
                (user) => {
                    unsubscribe();
                    resolve(user);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    isAuthenticated() {
        return auth.currentUser !== null;
    }
};
